<template>
  <button class="round-button" @click="onClick" :class="[mode]">
    <p class="body-semi-bold white">{{ content }}</p>
  </button>
</template>

<script>
export default {
  name: 'PaymentLinkRoundButton',
  props: {
    content: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
    },
  },
  methods: {
    onClick(value) {
      this.$emit('click', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .round-button {
    border: 0;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    background-color: $primary-500;
    border-radius: 26px;
    height: 52px;

    &:hover {
      background-color: $primary-700;
      border: 1px solid $primary-700;
    }

    @media (min-width: $breakpoint-large) {
      max-width: 126px;
      height: 48px;
    }

    &.semi-primary {
      background-color: $primary-100;
      border-color: $primary-100;

      p {
        @extend .body-regular;
        color: $primary-600 !important;
      }

      &:hover {
        background-color: $primary-300;
      }
    }
  }
</style>
